// Components
import { MainDiv } from "./styles";
import Title from "../../../title";
import PatientInfo from "./sections/patientInfo";
import IntrinsicMeasuresAssessments from "./sections/intrinsicMeasuresAssessments";
import ActivitiesPerformedControlGroup from "./sections/activitiesPerformedControlGroup";

const PatientData = ({
  patientData,
  clinicalScores,
  isLoadingClinicalScores,
  currentClinicalScore,
  setCurrentClinicalScore,
  showEditClinicalScore,
  setShowEditClinicalScore,
  refreshClinicalScores,
  setRefreshClinicalScores,
  intrinsicDates,
  isLoadingIntrinsicDates,
  newIntrinsicDate,
  setNewIntrinsicDate,
  newMeasureKey,
  setNewMeasureKey,
  showIntrinsicDatePopup,
  setShowIntrinsicDatePopup,
  refreshIntrinsicDates,
  setRefreshIntrinsicDates,
}) => {
  return (
    <>
      <Title title={"PATIENT DATA"} marginBottom="15px" />
      <MainDiv>
        <PatientInfo
          patientData={patientData}
          clinicalScores={clinicalScores}
          isLoadingClinicalScores={isLoadingClinicalScores}
          currentClinicalScore={currentClinicalScore}
          setCurrentClinicalScore={setCurrentClinicalScore}
          showEditClinicalScore={showEditClinicalScore}
          setShowEditClinicalScore={setShowEditClinicalScore}
          refreshClinicalScores={refreshClinicalScores}
          setRefreshClinicalScores={setRefreshClinicalScores}
        />
        <IntrinsicMeasuresAssessments
          patientData={patientData}
          intrinsicDates={intrinsicDates}
          isLoadingIntrinsicDates={isLoadingIntrinsicDates}
          newIntrinsicDate={newIntrinsicDate}
          setNewIntrinsicDate={setNewIntrinsicDate}
          newMeasureKey={newMeasureKey}
          setNewMeasureKey={setNewMeasureKey}
          showIntrinsicDatePopup={showIntrinsicDatePopup}
          setShowIntrinsicDatePopup={setShowIntrinsicDatePopup}
          refreshIntrinsicDates={refreshIntrinsicDates}
          setRefreshIntrinsicDates={setRefreshIntrinsicDates}
        />
        {patientData.aisnData.AISN_GROUP === "Control" && <ActivitiesPerformedControlGroup />}
      </MainDiv>
    </>
  );
};

export default PatientData;
